import { Button, useListContext, useNotify, useRefresh, useUnselectAll } from "react-admin";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import { candidateRequests } from "api/candidateApi";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";

const BulkMarkButtons = () => {
  const { selectedIds, data, resource } = useListContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const unselectAll = useUnselectAll(resource);

  const handleConfirm = async () => {
    const records = selectedIds.map(id => data[id]).filter(Boolean);
    const candidacyIds = records?.map(r => r.candidacyId);
    await dataProvider.customRequest(
      candidateRequests.preparatoryYears(),
      {
        candidacyIds,
      },
      "POST",
    );
    notify(`Избрани кандидати за Подготвителна година: ${selectedIds.length}`, { type: "success" });
    refresh();
    unselectAll();
  };

  return (
    <ConfirmModal
      titleContent="Потвърди промяната"
      onConfirm={handleConfirm}
      message="Сигурни ли сте, че искате да запишете избраните от Вас кандидати за Подготвителна година ?"
      triggerButton={
        <Button
          label="Избери кандидати за Подготвителна година"
          disabled={!selectedIds?.length}
          startIcon={<DoneOutlineIcon />}
        />
      }
    />
  );
};

export default BulkMarkButtons;
